<template>
  <div class="page-404">
    Запрашиваемый ресурс не найден<br />
    <router-link :to="{ name: 'home' }">
      Вернуться на главную
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Page404"
};
</script>

<style lang="scss">
.page-404 {
  padding: 40px 20px;
  font-size: 24px;
  line-height: 1.5;
  font-weight: bold;
  text-align: center;
}
</style>
